// @ts-strict-ignore
import analytics from '../analytics';
import { PublicProvider } from '../../api/Providers';
import { ClientProviderProfile } from '../../api/ProfileClientView';
import { openExternalUrl } from '../openExternalUrl';

export const callProviderWithPhone = (providerId: string | number, providerPhone: string) => {
  analytics.track('C Called Pro', {
    pro_id: providerId,
  });

  if (providerPhone && providerPhone.length) {
    openExternalUrl(`tel:${providerPhone}`, '_system', 'location=no,toolbarposition=top,enableViewportScale=yes');

    return true;
  }
  return false;
};

export const callProvider = (
  provider: PublicProvider | ClientProviderProfile,
) => callProviderWithPhone(
  provider.id,
  provider.public_phone_number,
);
